import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import '../styles/index.css';

const Header = ({ currentPage = '', lang = 'fr' }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const switchToEnglish = () => {
    const routeMap = {
      '': '/en',
      'caterers': '/en/caterers',
      'parents': '/en/parents',
      'schools': '/en/schools',
      'directions': '/en/directions',
      'platform': '/en/platform',
      'ecopulse': '/en/ecopulse',
      'ecoloop': '/en/ecoloop',
      'css': '/en/css',
      'coparentalite': '/en/coparenting'
    };
    navigate(routeMap[currentPage] || '/en');
  };

  const navTo = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <nav className="nav-header">
      <div className="nav-content">
        <div className="nav-logo" onClick={() => navTo('/')}>
          <img src="/logo-ecolunch.png" alt="EcoLunch" className="logo-image" />
        </div>
        <button className="nav-hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        <div className={`nav-overlay ${menuOpen ? 'nav-overlay-visible' : ''}`} onClick={() => setMenuOpen(false)}></div>
        <div className={`nav-links ${menuOpen ? 'nav-open' : ''}`}>
          <a onClick={() => navTo('/')} className={`nav-link nav-btn-feature ${currentPage === 'home' ? 'nav-btn-feature-active' : ''}`}>Accueil</a>
          <a onClick={() => navTo('/parents')} className={`nav-link nav-btn-actor nav-btn-parents ${currentPage === 'parents' ? 'nav-btn-active' : ''}`}>Parents</a>
          <a onClick={() => navTo('/caterers')} className={`nav-link nav-btn-actor nav-btn-caterers ${currentPage === 'caterers' ? 'nav-btn-active' : ''}`}>Traiteurs</a>
          <a onClick={() => navTo('/schools')} className={`nav-link nav-btn-actor nav-btn-schools ${currentPage === 'schools' ? 'nav-btn-active' : ''}`}>Écoles</a>
          <a onClick={() => navTo('/directions')} className={`nav-link nav-btn-actor nav-btn-directions ${currentPage === 'directions' ? 'nav-btn-active' : ''}`}>Directions</a>
          <a onClick={() => navTo('/css')} className={`nav-link nav-btn-actor nav-btn-css ${currentPage === 'css' ? 'nav-btn-active' : ''}`}>CSS</a>
          <a onClick={() => navTo('/platform')} className={`nav-link nav-btn-feature ${currentPage === 'platform' ? 'nav-btn-feature-active' : ''}`}>Architecture</a>
          <a onClick={() => navTo('/ecoloop')} className={`nav-link nav-btn-feature ${currentPage === 'ecoloop' ? 'nav-btn-feature-active' : ''}`}>EcoLoop</a>
          <a onClick={() => navTo('/coparentalite')} className={`nav-link nav-btn-feature ${currentPage === 'coparentalite' ? 'nav-btn-feature-active' : ''}`}>Co-Parentalité</a>
          <a onClick={() => navTo('/ecopulse')} className={`nav-link nav-btn-feature ${currentPage === 'ecopulse' ? 'nav-btn-feature-active' : ''}`}>EcoPulse</a>
          <div className="lang-selector">
            <button className={`lang-btn ${lang === 'fr' ? 'active' : ''}`} onClick={() => navigate(currentPage ? { '': '/', 'caterers': '/caterers', 'parents': '/parents', 'schools': '/schools', 'directions': '/directions', 'css': '/css', 'platform': '/platform', 'ecopulse': '/ecopulse', 'ecoloop': '/ecoloop', 'coparentalite': '/coparentalite' }[currentPage] || '/' : '/')}>FR</button>
            <button className={`lang-btn ${lang === 'en' ? 'active' : ''}`} onClick={switchToEnglish}>EN</button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
